import { VBtn } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v1'
import mixin_fields from './fields'
import EditModal from './EditModal.jsx'
import { getContractTypeListApi, changeStatusApi } from './service'
export default {
    mixins:[mixin_fields],
    data() {
        return {
            get_loading: false,
            list: [],
        }
    },
    computed: {
        fields_hash() {
          return this.fields.reduce((total, item) => {
              total[item.key] = item
              return total
          }, {})
        },
        tableFields() {
            const _this = this
            return [
                {
                    text: '合同大类',
                    value: 'main_type',
                    type: 'list_field',
                    item_key: 'key',
                    item_text: 'title',
                    items:this.fields_hash.main_type.items,
                    width: 100
                },
                {
                    text: '收支类别',
                    value: 'balance_type',
                    type: 'list_field',
                    item_key: 'key',
                    item_text: 'title',
                    items:this.fields_hash.balance_type.items,
                    width: 100
                },
                {
                    text: '合同小类',
                    value: 'sub_type',
                    width: 100,
                },
                {
                    text: '关联存货/课程',
                    value: 'relation_type',
                    type: 'list_field',
                    width: 150,
                    item_key: 'key',
                    item_text: 'title',
                    items:this.fields_hash.relation_type.items,
                },
                {
                    text: '负责团队',
                    value: 'teams',
                    width: 160,
                },
                {
                    text: '分析组审核',
                    value: 'need_at_audit',
                    width: 160,
                },
                {
                    text: '需要提交账单',
                    value: 'self_submit_bill',
                    width: 160,
                },
                {
                    text: '操作',
                    value: 'action_1',
                    width: 120,
                    fixed: 'right',
                    type: 'button_g_field',
                    buttons: ({target}) => {
                        return [
                            {
                              text: '编辑',
                              key: 'edit',
                              color: 'primary',
                              small: true,
                              _text: true,
                              callback: (data) => {
                                _this.edit(data)
                              }
                            },
                            {
                                text: target.del ? '启用' : '停用',
                                key: 'edit',
                                color:target.del ? 'primary' : 'error',
                                small: true,
                                _text: true,
                                callback: (data) => {
                                 //changeStatusApi
                                 this.$vModal.confirm({
                                    title: '提示',
                                    content: `是否${target.del ? '启用' : '停用'}该条目？`,
                                    onOk:({
                                        destroy,
                                        stopLoading
                                      }) => {
                                        changeStatusApi({id:target.id}).then(() => {
                                          this.$Message.success(`${target.del ? '启用' : '停用'}该条目成功！`)
                                          destroy()
                                          this.getData()
                                        }).catch(() => {
                                          stopLoading()
                                        })
                                      }  
                                  })
                                }
                              },
                          ]
                    } 
                }
            ]
        }
    },

    created() {
       this.getData()
    },
    methods: {
        getData() {
            this.get_loading = true
            getContractTypeListApi().then(res => {
                this.list = res
            }).finally(() => {
                this.get_loading = false
            })
        },
        edit(data) {
            this.$refs.modal.edit(data)
        },
        changePageSize() {

        },
        pageChange() {

        }
    },
    render() {
        const _this = this
        return <div>
            <div>
                <VBtn
                    color="primary"
                    on={{
                        click() {
                            _this.edit()
                        }
                    }}
                >
                    新增
                </VBtn>
            </div>
            <div>
            <VTable
                headers={this.tableFields}
                desserts={this.list}
                loading={this.get_loading}
                scopedSlots={{ 
                    need_at_audit:(val) => val ? '是' : '否',
                    self_submit_bill: (val) => val ? '是' : '否',
                    teams:(val) => val.map(item => item.name).join('，'),
                }}
             />
            </div>
            {/* <div class="paginate-fix-bottom">
              <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                      this.getInitList({
                        page:1,
                        per_page
                      })
                    },
                    pageChange:(page) => {
                      this.getInitList({
                        page
                      })
                    }
                  }
                }
              />
              </div> */}
              <EditModal
               ref="modal"
               on={{
                   success:() => {
                    _this.getData()
                   }
               }}/>
        </div>
    }
}